import React from 'react';
import { useLocation } from 'react-router-dom';

const TITLES = {
  '/jobs': 'Jobs',
  '/archive': 'Archive',
  '/dashboard': 'Dashboard',
  '/reports': 'Reports',
  '/users': 'User Management',
  '/clients': 'Client Management',
  '/categories': 'Category Management',
  '/statuses': 'Status Management',
};

export default function Topbar() {
  const { pathname } = useLocation();
  const title = TITLES[pathname] || 'Dashboard';
  const today = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <div style={{ height: 50, background: '#fff', borderBottom: '1px solid #e9ecef', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', flexShrink: 0 }}>
      <span style={{ fontSize: 16, fontWeight: 600, color: '#343a40' }}>{title}</span>
      <span style={{ fontSize: 12, color: '#6c757d' }}>{today}</span>
    </div>
  );
}
